import React from 'react';

function DevelopmentalInfo({ profile, onClose }) {
  const calculateAgeInMonths = (birthDate) => {
    const birth = new Date(birthDate);
    const now = new Date();
    const months = (now.getFullYear() - birth.getFullYear()) * 12 + now.getMonth() - birth.getMonth();
    return Math.max(0, months);
  };

  const ageInMonths = profile ? calculateAgeInMonths(profile.birthDate) : 0;

  // 월령별 발달 정보 (대한소아과학회 기준)
  const developmentalData = {
    0: {
      title: '0-1개월',
      emoji: '👶',
      physical: [
        '배를 바닥에 대고 눕히면 머리를 잠깐 들어올림',
        '큰 소리에 깜짝 놀람',
        '밝은 빛을 보면 눈을 깜빡임'
      ],
      cognitive: [
        '사람 얼굴을 응시함',
        '흑백 대비가 강한 물체에 관심을 보임',
        '엄마 목소리를 인식함'
      ],
      social: [
        '울음으로 불편함을 표현함',
        '달래주면 진정됨',
        '눈을 마주치려고 시도함'
      ],
      language: [
        '옹알이 시작 (아-, 우- 등)',
        '울음 소리로 배고픔/불편함을 표현',
        '사람 목소리에 반응함'
      ]
    },
    1: {
      title: '1-2개월',
      emoji: '👶',
      physical: [
        '배밀이 자세에서 머리를 45도 들어올림',
        '손을 입으로 가져감',
        '물체를 눈으로 따라감'
      ],
      cognitive: [
        '손을 펴고 주먹을 쥠',
        '움직이는 물체를 눈으로 추적함',
        '익숙한 얼굴을 알아봄'
      ],
      social: [
        '사회적 미소를 보이기 시작함',
        '사람 얼굴에 관심을 보임',
        '달래주면 금방 진정됨'
      ],
      language: [
        '구구, 가가 등의 소리를 냄',
        '울음소리가 다양해짐',
        '목소리 톤에 반응함'
      ]
    },
    2: {
      title: '2-3개월',
      emoji: '👶',
      physical: [
        '배밀이 자세에서 팔로 상체를 들어올림',
        '목을 가눔',
        '손을 함께 모음'
      ],
      cognitive: [
        '손을 보고 쳐다봄',
        '모빌 등 움직이는 장난감에 관심',
        '친숙한 사람을 알아봄'
      ],
      social: [
        '웃으면서 소리를 냄',
        '다른 아기를 보면 미소를 지음',
        '표정을 따라함'
      ],
      language: [
        '옹알이가 더 다양해짐',
        '말을 걸면 소리로 반응함',
        '다양한 울음소리로 욕구 표현'
      ]
    },
    3: {
      title: '3-4개월',
      emoji: '👶',
      physical: [
        '뒤집기 시도',
        '손을 뻗어 장난감을 잡음',
        '앉은 자세에서 머리를 안정적으로 유지'
      ],
      cognitive: [
        '장난감을 흔들면 소리가 나는 것을 이해',
        '거울 속 자신에게 미소를 지음',
        '손으로 물건을 탐색함'
      ],
      social: [
        '낯선 사람을 경계함',
        '놀아주면 즐거워함',
        '관심받는 것을 좋아함'
      ],
      language: [
        '바바, 다다 등의 소리를 냄',
        '자기 이름에 반응하기 시작',
        '소리 나는 쪽으로 고개를 돌림'
      ]
    },
    4: {
      title: '4-5개월',
      emoji: '🍼',
      physical: [
        '뒤집기를 함',
        '앉은 자세에서 지지 없이 잠깐 앉음',
        '발을 입으로 가져감'
      ],
      cognitive: [
        '물체가 떨어지면 쳐다봄',
        '원인과 결과를 이해하기 시작',
        '좋아하는 장난감을 찾음'
      ],
      social: [
        '거울 속 자신에게 웃음',
        '엄마와 떨어지는 것을 싫어함',
        '낯가림이 시작됨'
      ],
      language: [
        '옹알이가 더욱 다양해짐',
        '소리를 흉내 내려고 시도',
        '자기 목소리를 즐김'
      ]
    },
    5: {
      title: '5-6개월',
      emoji: '🍼',
      physical: [
        '혼자 앉음',
        '물건을 한 손에서 다른 손으로 옮김',
        '기기 시작 준비'
      ],
      cognitive: [
        '숨겨진 물건을 찾음',
        '이름을 부르면 반응함',
        '거울에 비친 자신을 알아봄'
      ],
      social: [
        '낯선 사람을 명확히 구별함',
        '애착 대상에게 강한 애착을 보임',
        '감정 표현이 다양해짐'
      ],
      language: [
        '자음+모음 조합 소리를 냄',
        '말투를 흉내 냄',
        '이름을 부르면 돌아봄'
      ]
    },
    6: {
      title: '6-7개월',
      emoji: '🍼',
      physical: [
        '배밀이나 기기 시작',
        '혼자 안정적으로 앉음',
        '엄지와 검지로 물건을 집음'
      ],
      cognitive: [
        '간단한 놀이를 이해함 (까꿍놀이)',
        '물체의 영속성을 이해하기 시작',
        '장난감을 두드리고 흔듦'
      ],
      social: [
        '낯가림이 심해짐',
        '엄마와 떨어지면 울음',
        '좋아하는 사람에게 안기려 함'
      ],
      language: [
        '마마, 다다, 바바 등을 말함',
        '억양을 흉내 냄',
        '간단한 몸짓 언어 사용'
      ]
    },
    7: {
      title: '7-8개월',
      emoji: '🧸',
      physical: [
        '기어다님',
        '붙잡고 서려고 시도',
        '물건을 집어서 옮김'
      ],
      cognitive: [
        '까꿍 놀이를 즐김',
        '간단한 지시를 이해함 ("안돼")',
        '원인과 결과를 명확히 이해함'
      ],
      social: [
        '낯선 사람을 무서워함',
        '거울 놀이를 즐김',
        '다른 아이들에게 관심을 보임'
      ],
      language: [
        '여러 음절을 조합함',
        '억양과 리듬을 흉내 냄',
        '특정 단어를 이해하기 시작'
      ]
    },
    8: {
      title: '8-9개월',
      emoji: '🧸',
      physical: [
        '붙잡고 섬',
        '능숙하게 기어다님',
        '엄지와 검지로 작은 물건을 집음'
      ],
      cognitive: [
        '물건을 찾아내는 놀이를 즐김',
        '간단한 문제를 해결함',
        '좋아하는 책을 가리킴'
      ],
      social: [
        '분리불안이 심해짐',
        '다른 아기의 행동을 따라함',
        '특정 사람에게 강한 애착'
      ],
      language: [
        '마마, 다다를 의미 있게 사용',
        '손흔들기 (바이바이)',
        '간단한 지시를 따름'
      ]
    },
    9: {
      title: '9-10개월',
      emoji: '🧸',
      physical: [
        '가구를 잡고 걸음',
        '계단을 기어서 오름',
        '잡고 일어섬'
      ],
      cognitive: [
        '간단한 퍼즐을 맞춤',
        '상자에 물건을 넣고 꺼냄',
        '친숙한 물건을 가리킴'
      ],
      social: [
        '관심받는 것을 즐김',
        '다른 아기와 같이 놀려고 시도',
        '칭찬을 좋아함'
      ],
      language: [
        '한두 단어를 말함',
        '간단한 요청을 이해함',
        '제스처로 의사소통함'
      ]
    },
    10: {
      title: '10-11개월',
      emoji: '🎈',
      physical: [
        '붙잡고 걸음',
        '혼자 몇 걸음 걸음',
        '계단을 오르내림'
      ],
      cognitive: [
        '모양 맞추기 놀이',
        '간단한 지시를 따름',
        '물건을 찾아냄'
      ],
      social: [
        '애정 표현을 함 (뽀뽀, 안기)',
        '다른 아이와 상호작용',
        '부모 행동을 따라함'
      ],
      language: [
        '2-3개 단어를 말함',
        '책을 읽어달라고 가져옴',
        '간단한 노래를 따라 부름'
      ]
    },
    11: {
      title: '11-12개월',
      emoji: '🎈',
      physical: [
        '혼자 걸음',
        '앉았다 일어섬',
        '공을 굴림'
      ],
      cognitive: [
        '간단한 명령을 이해하고 따름',
        '그림책의 그림을 가리킴',
        '숨바꼭질을 즐김'
      ],
      social: [
        '독립심이 생김',
        '도움을 요청함',
        '다른 아이들과 놀이를 시도'
      ],
      language: [
        '3-5개 단어를 말함',
        '간단한 질문에 고개를 끄덕임',
        '원하는 것을 가리키며 소리를 냄'
      ]
    },
    12: {
      title: '12-15개월',
      emoji: '🎈',
      physical: [
        '안정적으로 걸음',
        '계단을 오름',
        '공을 던짐'
      ],
      cognitive: [
        '간단한 지시를 따름',
        '그림을 가리키고 이름을 말함',
        '물건의 용도를 이해함'
      ],
      social: [
        '소유욕이 생김',
        '어른의 관심을 끌려고 함',
        '혼자 놀이를 즐김'
      ],
      language: [
        '5-10개 단어를 말함',
        '간단한 요청을 이해함',
        '몸짓과 말을 함께 사용'
      ]
    },
    15: {
      title: '15-18개월',
      emoji: '🎨',
      physical: [
        '달림',
        '계단을 오르내림',
        '숟가락을 사용함'
      ],
      cognitive: [
        '간단한 문제를 해결함',
        '그림책을 넘김',
        '상상 놀이를 시작함'
      ],
      social: [
        '다른 아이의 행동을 따라함',
        '자기 물건에 집착함',
        '칭찬을 좋아함'
      ],
      language: [
        '10-20개 단어를 말함',
        '두 단어를 조합함 ("엄마 물")',
        '간단한 노래를 따라 부름'
      ]
    },
    18: {
      title: '18-24개월',
      emoji: '🎨',
      physical: [
        '공을 차고 던짐',
        '계단을 혼자 오르내림',
        '컵을 사용해 마심'
      ],
      cognitive: [
        '색깔을 구분함',
        '간단한 퍼즐을 맞춤',
        '상상 놀이를 즐김'
      ],
      social: [
        '또래와 함께 놀이',
        '독립심이 강해짐',
        '감정 표현이 다양해짐'
      ],
      language: [
        '50개 이상의 단어를 말함',
        '2-3단어 문장을 만듦',
        '간단한 대화가 가능함'
      ]
    },
    24: {
      title: '24개월',
      emoji: '🎨',
      physical: [
        '뛰고 점프함',
        '계단을 성인처럼 오름',
        '크레용으로 그림을 그림'
      ],
      cognitive: [
        '색깔과 모양을 이해함',
        '간단한 지시를 따름',
        '역할 놀이를 즐김'
      ],
      social: [
        '친구들과 협력 놀이',
        '감정 조절이 나아짐',
        '규칙을 이해하기 시작함'
      ],
      language: [
        '200개 이상의 단어를 사용',
        '3-4단어 문장을 말함',
        '대화를 이어감'
      ]
    },
    30: {
      title: '30개월 (만 2.5세)',
      emoji: '🎭',
      physical: [
        '한 발로 잠깐 서기 가능',
        '공을 위로 던지기',
        '세발자전거 페달 밟기'
      ],
      cognitive: [
        '간단한 퍼즐 맞추기',
        '3-4가지 색깔 구분',
        '크기 비교하기 (큰 것/작은 것)'
      ],
      social: [
        '또래와 평행 놀이',
        '소유 개념 발달 ("내 것!")',
        '어른 행동 모방하기'
      ],
      language: [
        '300개 이상의 단어 사용',
        '4-5단어 문장 구사',
        '"왜?"라는 질문 시작'
      ]
    },
    36: {
      title: '36개월 (만 3세)',
      emoji: '🎪',
      physical: [
        '발을 바꿔가며 계단 오르내리기',
        '혼자 옷 벗기',
        '세발자전거 타기'
      ],
      cognitive: [
        '상징놀이 발달 (나무토막을 컵이라고 함)',
        '상상놀이 시작',
        '10까지 숫자 세기'
      ],
      social: [
        '자기 뜻대로 하려고 싸움이 많음',
        '타인의 호감과 관심을 얻으려 노력',
        '긴장 증가 (눈 깜박임, 손톱 물어뜯기 등)'
      ],
      language: [
        '애매한 단어와 무의미한 음률 좋아함',
        '변명하기 시작',
        '언어적 공격 나타남'
      ]
    },
    42: {
      title: '42개월 (만 3.5세)',
      emoji: '🎯',
      physical: [
        '한 발로 2-3초 서기',
        '공 받기 시작',
        '가위로 종이 자르기'
      ],
      cognitive: [
        '간단한 이야기 순서 이해',
        '시간 개념 발달 시작',
        '사물 분류하기 (색깔, 모양별)'
      ],
      social: [
        '친구와 함께 놀이하기 시작',
        '순서 기다리기 배우기',
        '감정 표현이 풍부해짐'
      ],
      language: [
        '완전한 문장으로 대화',
        '과거형 사용',
        '간단한 이야기 들려주기'
      ]
    },
    48: {
      title: '48개월 (만 4세)',
      emoji: '🎨',
      physical: [
        '한 발로 5초 이상 서기',
        '사람을 머리, 팔, 다리, 몸으로 그리기',
        '신발 끈 매기, 단추 채우기'
      ],
      cognitive: [
        '사물을 기준에 따라 분류',
        '크기 순서대로 배열하기',
        '주의 집중 시간 증가'
      ],
      social: [
        '우정 개념 생김',
        '공동 목적을 가지고 함께 놀기',
        '역할 놀이 즐김 (엄마아빠, 병원, 가게 놀이)'
      ],
      language: [
        '간단한 이야기 구사',
        '3-7개 단어로 완전한 문장',
        '"왜?", "어떻게?" 질문 많이 함'
      ]
    },
    54: {
      title: '54개월 (만 4.5세)',
      emoji: '🎓',
      physical: [
        '줄넘기 시작',
        '한 발로 깡충뛰기',
        '간단한 그림 그리기'
      ],
      cognitive: [
        '10개 이상 색깔 구분',
        '간단한 덧셈 개념',
        '요일 이해하기 시작'
      ],
      social: [
        '규칙 있는 게임 즐김',
        '친구와 협력하기',
        '경쟁심 발달'
      ],
      language: [
        '1500개 이상의 단어 사용',
        '복잡한 문장 구조',
        '반대말 이해'
      ]
    },
    60: {
      title: '60개월 (만 5세)',
      emoji: '🌟',
      physical: [
        '인라인 스케이트 배우기',
        '게임에서 출발, 회전, 정지 잘 함',
        '발 바꿔가며 긴 계단 내려오기'
      ],
      cognitive: [
        '10-12가지 색깔 구분',
        '정신적 이미지로 사고',
        '점차 논리적으로 변화'
      ],
      social: [
        '배움에 대한 열의 증가',
        '새로운 경험에 대한 호기심',
        '양심 발달'
      ],
      language: [
        '음성 체계 완성',
        '친구들과 대화 즐김',
        '수수께끼와 동화 좋아함'
      ]
    },
    66: {
      title: '66개월 (만 5.5세)',
      emoji: '📚',
      physical: [
        '자전거 타기 (보조바퀴 제거)',
        '줄넘기 연속으로 하기',
        '공 던지고 받기'
      ],
      cognitive: [
        '숫자와 글자 쓰기 시작',
        '간단한 단어 읽기',
        '시계 보기 시작'
      ],
      social: [
        '학교 준비 자세',
        '친구 관계 중요해짐',
        '갈등 해결 능력 향상'
      ],
      language: [
        '2000개 이상의 단어 사용',
        '문법 오류 스스로 고침',
        '논리적 설명 가능'
      ]
    },
    72: {
      title: '72개월 (만 6세, 초등 입학)',
      emoji: '🎒',
      physical: [
        '달리기, 점프, 균형잡기 능숙',
        '연필 올바르게 잡고 글씨 쓰기',
        '신발끈 묶기, 가위질 능숙'
      ],
      cognitive: [
        '논리적 사고 기초 형성',
        '원인과 결과 파악',
        '시간 개념 이해',
        '관찰로 원리 파악하려 함'
      ],
      social: [
        '성격과 개성 거의 형성',
        '협력하여 목표 달성',
        '성숙한 방식으로 갈등 해결'
      ],
      language: [
        '2500-5000개 단어 사용',
        '복잡한 문장 구조 이해',
        '읽기와 쓰기 가능',
        '추상적 용어 이해'
      ]
    }
  };

  const getAgeGroup = (months) => {
    if (months < 1) return 0;
    if (months < 2) return 1;
    if (months < 3) return 2;
    if (months < 4) return 3;
    if (months < 5) return 4;
    if (months < 6) return 5;
    if (months < 7) return 6;
    if (months < 8) return 7;
    if (months < 9) return 8;
    if (months < 10) return 9;
    if (months < 11) return 10;
    if (months < 12) return 11;
    if (months < 15) return 12;
    if (months < 18) return 15;
    if (months < 24) return 18;
    if (months < 30) return 24;
    if (months < 36) return 30;
    if (months < 42) return 36;
    if (months < 48) return 42;
    if (months < 54) return 48;
    if (months < 60) return 54;
    if (months < 66) return 60;
    if (months < 72) return 66;
    return 72;
  };

  const ageGroup = getAgeGroup(ageInMonths);
  const data = developmentalData[ageGroup];

  if (!data) return null;

  return (
    <div className="fade-in" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
      padding: '20px'
    }}>
      <div className="slide-up" style={{
        backgroundColor: 'white',
        borderRadius: '24px',
        padding: '40px',
        maxWidth: '600px',
        width: '100%',
        maxHeight: '90vh',
        overflow: 'auto',
        position: 'relative'
      }}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#8B7355'
          }}
        >
          ×
        </button>

        <div style={{
          textAlign: 'center',
          marginBottom: '32px'
        }}>
          <div style={{ fontSize: '64px', marginBottom: '16px' }}>{data.emoji}</div>
          <h2 style={{
            color: '#E8A87C',
            fontSize: '28px',
            marginBottom: '8px'
          }}>
            {ageInMonths}개월 발달 정보
          </h2>
          <p style={{
            color: '#8B7355',
            fontSize: '14px'
          }}>
            {profile.name}이의 현재 월령: {ageInMonths}개월
          </p>
          <div style={{
            backgroundColor: '#FAF3E8',
            borderRadius: '12px',
            padding: '12px',
            marginTop: '16px',
            fontSize: '12px',
            color: '#8B7355'
          }}>
            💡 대한소아과학회 기준 • 개인차가 있을 수 있습니다
          </div>
        </div>

        {/* 신체 발달 */}
        <div style={{
          backgroundColor: '#FFF8F0',
          borderRadius: '16px',
          padding: '24px',
          marginBottom: '16px'
        }}>
          <h3 style={{
            color: '#E8A87C',
            fontSize: '18px',
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            💪 신체 발달
          </h3>
          <ul style={{
            listStyle: 'none',
            padding: 0,
            margin: 0
          }}>
            {data.physical.map((item, index) => (
              <li key={index} style={{
                color: '#8B7355',
                fontSize: '14px',
                marginBottom: '8px',
                paddingLeft: '20px',
                position: 'relative',
                lineHeight: '1.6'
              }}>
                <span style={{
                  position: 'absolute',
                  left: '0',
                  color: '#E8A87C'
                }}>✓</span>
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* 인지 발달 */}
        <div style={{
          backgroundColor: '#F0F8FF',
          borderRadius: '16px',
          padding: '24px',
          marginBottom: '16px'
        }}>
          <h3 style={{
            color: '#64B5F6',
            fontSize: '18px',
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            🧠 인지 발달
          </h3>
          <ul style={{
            listStyle: 'none',
            padding: 0,
            margin: 0
          }}>
            {data.cognitive.map((item, index) => (
              <li key={index} style={{
                color: '#5A7A8C',
                fontSize: '14px',
                marginBottom: '8px',
                paddingLeft: '20px',
                position: 'relative',
                lineHeight: '1.6'
              }}>
                <span style={{
                  position: 'absolute',
                  left: '0',
                  color: '#64B5F6'
                }}>✓</span>
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* 사회성/정서 발달 */}
        <div style={{
          backgroundColor: '#FFF0F5',
          borderRadius: '16px',
          padding: '24px',
          marginBottom: '16px'
        }}>
          <h3 style={{
            color: '#E57373',
            fontSize: '18px',
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            ❤️ 사회성/정서 발달
          </h3>
          <ul style={{
            listStyle: 'none',
            padding: 0,
            margin: 0
          }}>
            {data.social.map((item, index) => (
              <li key={index} style={{
                color: '#8B5A6F',
                fontSize: '14px',
                marginBottom: '8px',
                paddingLeft: '20px',
                position: 'relative',
                lineHeight: '1.6'
              }}>
                <span style={{
                  position: 'absolute',
                  left: '0',
                  color: '#E57373'
                }}>✓</span>
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* 언어 발달 */}
        <div style={{
          backgroundColor: '#F0FFF4',
          borderRadius: '16px',
          padding: '24px',
          marginBottom: '24px'
        }}>
          <h3 style={{
            color: '#66BB6A',
            fontSize: '18px',
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            🗣️ 언어 발달
          </h3>
          <ul style={{
            listStyle: 'none',
            padding: 0,
            margin: 0
          }}>
            {data.language.map((item, index) => (
              <li key={index} style={{
                color: '#4A7C4E',
                fontSize: '14px',
                marginBottom: '8px',
                paddingLeft: '20px',
                position: 'relative',
                lineHeight: '1.6'
              }}>
                <span style={{
                  position: 'absolute',
                  left: '0',
                  color: '#66BB6A'
                }}>✓</span>
                {item}
              </li>
            ))}
          </ul>
        </div>

        <div style={{
          backgroundColor: '#FFF3E0',
          borderRadius: '12px',
          padding: '16px',
          marginBottom: '20px',
          fontSize: '13px',
          color: '#8B7355',
          lineHeight: '1.6'
        }}>
          ⚠️ <strong>참고사항</strong><br />
          모든 아기는 자신만의 속도로 성장합니다. 위 발달 정보는 일반적인 기준이며,
          실제 발달 속도는 개인차가 있을 수 있습니다. 발달이 현저히 늦다고 생각되면
          소아청소년과 전문의와 상담하세요.
        </div>

        <button
          onClick={onClose}
          style={{
            width: '100%',
            padding: '16px',
            backgroundColor: '#E8A87C',
            color: 'white',
            border: 'none',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#D4956B'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#E8A87C'}
        >
          닫기
        </button>
      </div>
    </div>
  );
}

export default DevelopmentalInfo;
